import { fetchBasketFromCms } from '@/contentful/entries';
import React, { useContext, useEffect, useState } from 'react';
import FilledBasket from '../../basket/filledBasket';
import './_overview.scss';
import Spinner from '@/generic-components/Spinner';
import { IBasket, IEcProduct } from '@/types/simo/basket';
import CheckBox from '@/generic-components/checkbox/checkbox';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { bodyTextRenderOptions } from '@/contentful/helper';
import { AppContext } from '@/stateManager';
import { view } from '@nuuday/data-layer';

interface IBasketCmsContainer {
  basket: IBasket;
  checkoutCms: any;
  setActiveSection: any;
  ecProducts: IEcProduct[];
}

const Overview = (props: IBasketCmsContainer) => {
  const { basket, checkoutCms, setActiveSection, ecProducts } = props;
  const noOfSubscription = basket.priceSummaries[0]?.recurring.length;
  const portedMobileNumber = basket.priceSummaries[0]?.recurring.filter((entry) => {
    return Boolean(entry.configuration.portedMobileNumber);
  }).length;
  const [basketCms, setBasketCms] = useState<IBasketCmsContainer | any>();
  const [isCmsLoading, setIsCmsLoading] = useState<boolean>(true);

  const [inputErrors, setInputErrors] = useState({});
  const context = useContext<any>(AppContext);
  const {
    /* valgfriChecked, */ existingSubChecked,
    termsChecked
  } = context.store.checkoutOverviewStep;

  useEffect(() => {
    view({
      pageName: 'approve',
      siteSection: ['i hjemmet', 'mobil', 'simonly'],
      customEvent: ['ecCheckout'],
      pageType: 'simo checkout 6/8',
      ecProducts,
      mvGrossAdds: ecProducts?.length || 0
    });
    const fetchFromCms = async () => {
      try {
        await fetchBasketFromCms(setBasketCms);
        setIsCmsLoading(false);
      } catch (error) {
        console.error(error);
      }
    };
    fetchFromCms();
    context.dispatch({
      type: 'getBasket',
      payload: {
        basket: { responseCode: '', basket }
      }
    });
  }, []);

  const handleCheckbox = (name: any) => {
    const checkboxValue = context.store.checkoutOverviewStep[name];
    const newValue = { ...context.store.checkoutOverviewStep, [name]: !checkboxValue };
    context.dispatch({
      type: 'checkoutOverviewStep',
      payload: { checkoutOverviewStep: newValue }
    });
  };

  const onContinue = async () => {
    let errors = {};
    if (!termsChecked) {
      errors = { ...errors, termsChecked: 'Du mangler at acceptere et eller flere af vilkårene' };
    }

    if (portedMobileNumber) {
      if (!existingSubChecked) {
        errors = {
          ...errors,
          existingSubChecked: 'Du mangler at acceptere et eller flere af vilkårene'
        };
      }
    }
    if (Object.keys(errors).length === 0) {
      setActiveSection();
    } else {
      setInputErrors(errors);
    }
  };
  return (
    <>
      {isCmsLoading ? (
        <Spinner />
        ) : (
          <div className="overview">
          <div className="overview__basket">
            <FilledBasket
              isOverviewStep
              basket={basket}
              noOfSubscription={noOfSubscription}
              basketCms={basketCms.basket && basketCms.basket}
              />
          </div>
          <div>
            <div className="overview__checkbox__header">
              {checkoutCms && checkoutCms.checkoutCms.overviewCheckboxTermsHeader}
            </div>
            {portedMobileNumber !== 0 && (
              <>
                <CheckBox
                  checked={existingSubChecked}
                  labelText={
                    checkoutCms &&
                    documentToReactComponents(
                      checkoutCms.checkoutCms.overviewExistingSubscriptions.json,
                      bodyTextRenderOptions
                      )
                    }
                    onChange={() => handleCheckbox('existingSubChecked')}
                    labelClassName="overview__checkbox__description"
                    />
                {inputErrors['existingSubChecked'] && (
                  <div className="overview__checkbox__error-text">
                    <div className="component-textinput__label__error-text">
                      {inputErrors['existingSubChecked']}
                    </div>
                  </div>
                )}
              </>
            )}
            <CheckBox
              checked={termsChecked}
              labelText={
                checkoutCms &&
                documentToReactComponents(
                  checkoutCms.checkoutCms.overviewCheckboxTerms.json,
                  bodyTextRenderOptions
                  )
                }
                onChange={() => handleCheckbox('termsChecked')}
                labelClassName="overview__checkbox__description"
                />
            {inputErrors['termsChecked'] && (
              <div className="overview__checkbox__error-text">
                <div className="component-textinput__label__error-text">
                  {inputErrors['termsChecked']}
                </div>
              </div>
            )}
            <div className="delivery__button">
              <button
                className="component-contact__button ys-button ys-button--cta ys-button--block"
                onClick={onContinue}
                >
                <span className="ys-button__text">Fortsæt</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Overview;
